// @ts-nocheck
export const APP_URL =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_APP_URL
    : window.CONFIG.APP_URL;

export const APP_API_URL =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_APP_API_URL
    : window.CONFIG.APP_API_URL;

export const APP_API_URL_SERVICE =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_APP_API_URL_SERVICE
    : window.CONFIG.APP_API_URL_SERVICE;

export const APP_API_VERSION =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_APP_API_VERSION
    : window.CONFIG.APP_API_VERSION;

export const APP_API_SCOPES =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_APP_API_SCOPES
    : window.CONFIG.APP_API_SCOPES;

export const APP_NAME =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_APP_NAME
    : window.CONFIG.APP_NAME;

export const APP_SHARED_SECRET =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_APP_SHARED_SECRET
    : window.CONFIG.APP_SHARED_SECRET;

export const APP_API_KEY =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_APP_API_KEY
    : window.CONFIG.APP_API_KEY;

export const INTERCOM_KEY =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_INTERCOM_KEY
    : window.CONFIG.INTERCOM_KEY;

export const HOTJAR_KEY =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_HOTJAR_KEY
    : window.CONFIG.HOTJAR_KEY;

export const MIXPANEL_KEY =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_MIXPANEL_KEY
    : window.CONFIG.MIXPANEL_KEY;

export const BUGSNAG_KEY =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_BUGSNAG_KEY
    : window.CONFIG.BUGSNAG_KEY;
